import cardValidator from 'card-validator';

import {
  Card as PaymentCardIcon,
  PaymentMasterCard as PaymentMasterCardIcon,
  PaymentVisa as PaymentVisaIcon,
} from '../components/icons';
import * as Store from '../weborder/Store';

const getState = () => {
  const store = Store.getStoreInstance();

  return store?.getState();
};

const displayConsentToSaveCard = (): boolean => {
  const flipdishAppConfig = getState().flipdish.AppConfig;

  if (flipdishAppConfig.status === 'success') {
    return flipdishAppConfig.data.DisplayConsentToSaveCard;
  }

  return false;
};

const getCardIcon = (card: cardValidator.Card): JSX.Element => {
  if (isVisa(card)) {
    return PaymentVisaIcon();
  }

  if (isMasterCard(card)) {
    return PaymentMasterCardIcon();
  }

  return PaymentCardIcon();
};

const getIsHTTPS = (): boolean => window.location.protocol === 'https:';

const isMasterCard = (card: cardValidator.Card): boolean =>
  card?.type === 'mastercard';

const isVisa = (card: cardValidator.Card): boolean => card?.type === 'visa';

export const creditCardUtils = {
  displayConsentToSaveCard,
  getCardIcon,
  getIsHTTPS,
  isMasterCard,
  isVisa,
};
